import Backbone from "backbone";

import readlangClient from "readlangClient";
import * as splitTest from "splitTest";

class EndOfTextView extends Backbone.View {
  vote: number;
  votedAlready: boolean;

  remoteUserWords: Backbone.Collection & { totalCount: number };
  user: Backbone.Model;

  userWordsFetched = false;

  starterStory = false;

  continueText: {
    _id: string;
    title: string;
  } = undefined;

  initialize(options) {
    this.remoteUserWords = options.remoteUserWords;
    this.user = options.user;
    this.vote = options.model.get("yourVote") ?? 0;
    this.votedAlready = this.vote !== 0;
    this.starterStory = options.starterStory;

    this.render();
    this.fetchUserWords();
    this.fetchContinueText();

    splitTest.trackEvent("textComplete");
  }

  fetchUserWords() {
    // Not sure why awaiting this doesn't work, so using success callback instead
    this.remoteUserWords.fetch({
      data: {
        bookID: this.model.id,
      },
      success: () => {
        this.userWordsFetched = true;
        this.render();
      },
    });
  }

  fetchContinueText() {
    readlangClient.request("GET", "/api/dashboard/continueText", {}, (data) => {
      this.continueText = data;
      this.render();
    });
  }

  textType() {
    return this.model.get("totalWords") > 10000
      ? "book"
      : this.model.get("category") === "Fiction"
        ? "story"
        : this.model.has("youTubeID")
          ? "video"
          : "text";
  }

  render() {
    const plural = !this.userWordsFetched || this.remoteUserWords.length !== 1;
    const html = `
    <div id="endOfText" dir="LTR">
      <h2 class="endOfTextHeader">Congratulations!</h2>
      <p>You've reached the end of <i>${this.model.get("title")}</i>.</p>
      ${this.renderVoteSection()}
      <p class="noMobile">
        This ${this.textType()} was ${
          this.model.get("metrics").words
        } words long and while reading you translated ${
          this.userWordsFetched ? this.remoteUserWords.totalCount : "..."
        } word${plural ? "s" : ""} or phrase${plural ? "s" : ""}.</p>
      ${this.renderFlashcardsSection()}
      ${
        this.continueText
          ? `<p><a href="/library/${this.continueText._id}">Read Next: "${this.continueText.title}"</a></p>`
          : ""
      }
      <p class="nextText">
      </p>
      <p>
        ${
          this.model.get("starterStory")
            ? '<a href="/">← Return Home</a>'
            : this.user.id === this.model.get("ownerID")
              ? '<a href="/myTexts">← Return to My Texts</a>'
              : '<a href="/library">← Return to Public Library</a>'
        }
      </p>
    </div>`;

    this.$el.html(html);
    return this;
  }

  renderVoteSection() {
    if (!this.model.get("public") || this.votedAlready) {
      return "";
    }

    return `<p>Did you like this ${this.textType()}?</p>
      <div class="pageEndButtons">
      <button id="upVote" ${this.vote > 0 ? 'class="selected"' : ""}>
        Yes &nbsp; <span style="font-size: 120%">👍</span>
      </button>
      <button id="downVote" ${this.vote < 0 ? 'class="selected"' : ""}>
        No &nbsp; <span style="font-size: 120%">👎</span>
      </button>
      </div>`;
  }

  renderFlashcardsSection() {
    if (!this.userWordsFetched || this.remoteUserWords.totalCount < 1) {
      return "";
    }

    return `
    <p>
      <a href="/${this.model.get("language")}/flashcards/book/${
        this.model.id
      }">Practice Flashcard${this.remoteUserWords.totalCount === 1 ? "" : "s"}</a>
    </p>
    `;
  }

  events(): Backbone.EventsHash {
    return {
      "click #upVote": () => {
        console.log("up vote");
        this.vote = this.vote > 0 ? 0 : 1;
        (this.model as any).vote(this.vote);
        this.render();
      },
      "click #downVote": () => {
        console.log("down vote");
        this.vote = this.vote < 0 ? 0 : -1;
        (this.model as any).vote(this.vote);
        this.render();
      },
    } as Backbone.EventsHash;
  }
}

export default EndOfTextView;
